import { useMutation, useQueryClient } from '@tanstack/react-query';
import { payersApi } from '../api/payersApi';
import { payerKeys } from '../queryKeys';

// Agency-only — calls the existing charting module's endpoint directly
// rather than duplicating activation logic in the setup module.
export function useActivateMapVersion(payerId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (versionId: string) => payersApi.activateMapVersion(versionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: payerKeys.map(payerId) });
    },
  });
}
